import { Button } from "@chakra-ui/button";
import { useHelpContext } from "domains/help-tour/helpProvider";
import { usePackContext } from "domains/pack";
import { usePack } from "lib/hooks";
import { isReadOnly } from "lib/utils";
import { FC } from "react";

export const ToggleHelpMode:FC<any> = (props) => {
  const { hideHelp, showHelp, isHelpActive } = useHelpContext();
  const onHelpClick = () => isHelpActive ? hideHelp() : showHelp();
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);

  if (isReadOnly(pack)) {
    return null;
  }

  return (
    <Button onClick={() => onHelpClick()} {...props}>
      {isHelpActive ? 'Hide' : 'Show'} Help
    </Button>
  )
}
